"use client";

/**
 * ModernButton — alias del Button v2 líquido.
 * Acepta `loadingText` por compat (se ignora; el label lo pone el children).
 */

import * as React from "react";
import { Button, type ButtonProps } from "components/ui/v2/button";

export type ModernButtonProps = ButtonProps & {
  loadingText?: string;
};

const ModernButton = React.forwardRef<HTMLButtonElement, ModernButtonProps>(
  ({ loadingText: _loadingText, ...props }, ref) => (
    <Button ref={ref} {...props} />
  )
);

ModernButton.displayName = "ModernButton";

export default ModernButton;
export { ModernButton };
